import { useTranslation } from 'react-i18next';
import './style.scss';
import { Breadcrumbs } from '@components/Breadcrumbs';
import { breadcrumbs } from '@components/Breadcrumbs/consts';
import { ErrorNotifications } from '@components/ErrorNotifications';
import { getBacklinkUrl, SiteConfig, onContinueShoppingClick } from '@utils';

export const EmptyCart = () => {
  const { t } = useTranslation();
  const { locale } = SiteConfig.getConfig();

  const handleContinueShopping = () => {
    onContinueShoppingClick('emptyCart');
    const continueShoppingUrl = getBacklinkUrl();
    setTimeout(() => window.location.replace(continueShoppingUrl), 100);
  };

  return (
    <div className="empty-cart">
      <div className="empty-cart__breadcrumbs">
        <Breadcrumbs items={breadcrumbs(locale)} />
      </div>
      <ErrorNotifications />
      <div className="empty-cart__content">
        <h1 className="empty-cart__title">{t('cart.emptyCart.title')}</h1>
        <button
          type="button"
          className="common-button primary regular empty-cart__button"
          onClick={handleContinueShopping}
        >
          {t('cart.emptyCart.continueShopping')}
        </button>
      </div>
    </div>
  );
};
